<template>
  <div v-if="isUserAuthenticated()">
    <v-toolbar flat color="white">
      <v-toolbar-title>Notes téléphoniques</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <v-btn slot="activator" color="primary" dark class="mb-2" @click="createItem()">Nouvelle note</v-btn>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <!-- <v-flex xs12 sm12 md12>
                customerId:{{customerId}}<br/>
                Date:{{editedItem.Date}}<br/>
                </v-flex> -->
                <v-flex xs4 sm4 md4>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="editedItem.Date"
                      label="Date"
                      persistent-hint
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="date" no-title @input="saveDate(editedItem, date)"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs8 sm8 md8>
                  <v-checkbox v-model="editedItem.IsActive" label="Est actif"></v-checkbox>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-textarea v-model="editedItem.Note" label="Note" rows="2" autofocus></v-textarea>
                </v-flex>
                
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="close">Annuler</v-btn>
            <v-btn color="blue darken-1" flat @click.native="save">Sauvegarder</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :pagination.sync="pagination"
        hide-actions
        class="elevation-1"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column sortable', 
                pagination.descending ? 'desc' : 'asc', 
                header.value === pagination.sortBy ? 'active' : '',
                header.align ? 'text-xs-' + header.align : ''
              ]"
              @click="changeSort(header.value)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.Date | formatDateTime }}</td>
          <td class="text-xs-left">{{ props.item.Note }}</td>
          <td class="justify-center layout px-0">
            <v-icon
              medium
              class="mr-2"
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
            <!-- <v-icon
              small
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon> -->
          </td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <!-- <v-pagination v-model="pagination.page" :length="pages"></v-pagination> -->
        <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
      </div>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'
import auth from '@/auth'
import APICustomerPhoneNote from '@/api/customerphonenote'
const APIService = new APICustomerPhoneNote();

var axios = require('axios')

export default {

  props: {
    customerId: {
      type: Number,
      required: true
   }
  },
  data() {
    return {
        date: null,
        dateFormat: 'YYYY-MM-DD',
        timeFormat: 'HH:mm:ss',
        menu: false,
        modal: false,

        dialog: false,
        loading: false,
        pagination: {
          sortBy: 'Date',
          page: 1,
          rowsPerPage: 3
        },
        headers : [
          { text: 'Date', value: 'Date', align: 'left' },
          { text: 'Note', value: 'Note', align: 'left' },
          { text: 'Actions', value: 'Actions', align: 'center', sortable: false }
        ],
        items: [],
        editedIndex: -1,
        editedItem: {},
        defaultItem: {
          Date: moment().format("YYYY-MM-DD"),
          Note: '',
          IsActive: true
        }
    }
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nouvelle note téléphonique' : 'Modification de la note téléphonique'
    },

    pages () {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null)
        return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    customerId () {
      this.initialize()
    },
    items () {
      this.$nextTick(() => {
        this.pagination.totalItems = this.items.length
      })
    }
  },

  created(){
    this.initialize()
  },

  methods: {
    isUserAuthenticated() {
      return auth.isUserAuthenticated()
    },

    logout() {
      auth.logout()
    },

    initialize () {
      var notes = APIService.getAll(this.customerId).then(response =>  {
            this.items = response.data
        }
      )
    },

    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    
    createItem () {
      //debugger;
      this.editedIndex = -1
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedItem.OriginalDate = this.editedItem.Date
      this.editedItem.Date = moment().format(this.dateFormat)
      this.editedItem.CustomerID = this.customerId
      this.dialog = true
    },
    
    editItem (item) {
      //debugger;
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.OriginalDate = this.editedItem.Date
      this.editedItem.Date = moment(this.editedItem.Date).format(this.dateFormat)
        //this.timeFormat)
      this.dialog = true
    },

    close () {
      this.dialog = false
      this.date = null
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      
      if (this.editedIndex > -1) {
        //UPDATE
        //debugger
        if (this.date) {
          var time = moment().format(this.timeFormat)
          this.editedItem.Date = moment(this.editedItem.Date + ' ' + time).format(this.dateFormat + ' ' + this.timeFormat)
        }
        else {
          this.editedItem.Date = this.editedItem.OriginalDate
        }
        APIService.update(this.editedItem, this.customerId).then(response => {
          //debugger;
          if(response.data)
          {
            if (this.editedItem.IsActive)
            {
              Object.assign(this.items[this.editedIndex], this.editedItem)
            }
            else
            {
              this.items.splice(this.editedIndex, 1)
            }
          }
          this.close()
        })
      } else {
        //CREATE
        var time = moment().format(this.timeFormat)
        this.editedItem.Date = moment(this.editedItem.Date + ' ' + time).format(this.dateFormat + ' ' + this.timeFormat)
        APIService.create(this.editedItem, this.customerId).then(response => {
          //debugger;
          if(response.data)
            this.items.push(response.data)

          this.close()
        })
      }
    },

    saveDate(item, date) {
      item.Date = date
      //menu.save(date)
      this.menu = false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/GridCustomerPhoneNote.vue